import {  Component, OnInit, OnDestroy } from '@angular/core';
import { EntityrecordApi, } from '../../sdk/services/custom';
import * as _ from "lodash";
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { FieldType } from 'ng-formly';

@Component({
	selector: 'formly-field-textarea',
	template: `
	<i *ngIf="icon" [class]="icon"></i>
	<a *ngIf="required"><font color="red"> *</font></a>
	<div class="btn-group">
	<!--
		<a class="btn btn-secondary btn-sm" *ngIf="entityrecord" (click)="addNewRecord()" data-toggle="tooltip" data-placement="top" title="Add New" style="color:GREEN;border:none;">
			<i class="fa fa-plus" aria-hidden="true"></i>
		</a>
		<a class="btn btn-secondary btn-sm" *ngIf="apiData" (click)="viewRecord()" data-toggle="tooltip" data-placement="top" title="View" style="border:none;">
			<i class="fa fa-eye" aria-hidden="true"></i>
		</a>
		<a class="btn btn-secondary btn-sm" (click)="resetSelection()" data-toggle="tooltip" data-placement="top" title="Reset" style="color:RED;border:none;">
			<i class="fa fa-eraser" aria-hidden="true"></i>
		</a>
	-->
		<a class="btn btn-secondary btn-sm" *ngIf="apiData" (click)="refreshOptions()" data-toggle="tooltip" data-placement="top" title="Refresh" style="color:DODGERBLUE;border:none;">
			<i class="fa fa-refresh" aria-hidden="true"></i>
		</a>
	</div>
	<textarea rows="1" [name]="key" [formControl]="formControl" [cols]="to.cols"
      [rows]="to.rows" class="form-control" 
      [formlyAttributes]="field">
    </textarea>
    `,
})

export class TextAreaField extends FieldType implements OnInit, OnDestroy {
	formulae = [];
	modelValues = [];
	currentuser;
	appId;
	apiData = false;
	ngUnsubscribe: Subject<void> = new Subject<void>();

	get type() {
		return this.to.type || 'text';
	}

	get readonly() {
		return this.to.readonly || false;
	}

	get required() {
		return this.to.required || false;
	}

	get icon() {
		return this.to.icon || null;
	}

	constructor(private _LoopBackAuth: LoopBackAuth,
		private _PlatformApp: PlatformApp,
		private _EntityrecordApi: EntityrecordApi) {
		super();
	}

	ngOnInit() {

		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};

		for (var key in this.form.controls)
			this.form['newcontrols'][key] = this.form.controls[key];

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl)
				this.addWatcher(this.field.formControl);
		}

		if (this.to.readonly)
			this.to.disabled = true;

		if (this.field.defaultValue && !this.model[this.key])
			this.formControl.setValue(this.field.defaultValue);

		if (this.model[this.key]) {
			this.formControl.setValue(this.model[this.key]);
			this.processFormulae(this.model[this.key]);
		}

		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable("platformApp"))
			this.appId = PlatformApp.getAppVariable("referenceAppId");
		else
			this.appId = this.currentuser.appId;

		if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
			this.apiData = true;
			if (this.model && this.model[this.field["parentLookupField"]])
				this.pullLookupData(this.model[this.field["parentLookupField"]]);
			this.setNewFormControl(this.field['parentLookupField']);
			if (this.form.controls[this.field["parentLookupField"]])
				this.form['subscriptions'].push(this.form.controls[this.field["parentLookupField"]].valueChanges
					.subscribe((parentLookupFieldValue: any) => {
						this.pullLookupData(parentLookupFieldValue);
					}));
		}
	}

	public refreshOptions() {
		if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
			if (this.model && this.model[this.field["parentLookupField"]])
				this.pullLookupData(this.model[this.field["parentLookupField"]]);
		}
	}

	private pullLookupData(parentLookupFieldValue) {
		if (parentLookupFieldValue)
			this.form['subscriptions'].push(this._EntityrecordApi.findById(parentLookupFieldValue)
				.subscribe((record) => {
					if (record && record['data'] && record['data'][this.field['parentLookupDataField']])
						this.formControl.setValue(record['data'][this.field['parentLookupDataField']]);
				}));
	}

	private addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges
			.takeUntil(this.ngUnsubscribe)
			.subscribe((updatedValue: any) => {
				this.processFormulae(updatedValue);
			}));
	}

	private processFormulae(currentValue) {
		for (var i = 0; i < this.formulae.length; i++) {
			var formula = this.formulae[i];
			if (this.setModelValues(formula['fields'], currentValue)) {
				this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
			}
		}
	}

	private setModelValues(fieldArray, updatedValue) {
		var requiredFieldsExist = true;
		this.modelValues = [];
		for (var j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] == this.field.key) {
					this.modelValues.push(updatedValue);
				} else {
					this.modelValues.push(this.model[fieldArray[j]]);
				}
			}
		}
		return requiredFieldsExist;
	}

	private setResults(resultArray, value): void {
		for (var i = 0; i < resultArray.length; i++) {
			var resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else {
					this.model[resultField] = value;
				}
			}
		}
	}

	private getValue(field: any, subfield: string) {
		if (field['templateOptions'] && field['templateOptions'][subfield])
			return field['templateOptions'][subfield];
		if (field['expressionProperties'] && (field['expressionProperties'].hasOwnProperty(subfield)))
			return evalExpression(field['expressionProperties'][subfield].expression, this, [this.model, this.options.fromState]);
		if (field[subfield])
			return field[subfield];
		return null;
	}

	private setNewFormControl(fieldname: string) {
		if (this.form['newcontrols'][fieldname])
			if (!this.form.controls[fieldname])
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			else
				this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
		else
			console.log('Error !!! No Form Control for Field: "' + fieldname + '" in textarea-field of "' + this.key + '"');
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}
}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/textareafield.ts